import React, { useState } from "react";

import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { userService } from "services";

const EditProfileForm = ({ user, setUser, handleClose }) => {
  const [error, setError] = useState(null);

  // updateType: "MACHINE_DETAILS', 'FAA', 'DL', 'INSURANCE', 'PILOT_LICENSE'",
  const formik = useFormik({
    initialValues: {
      updateType: "MACHINE_DETAILS",
      uasManufacturer: user?.uasManufacturer || "",
      uasModel: user?.uasModel || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      uasManufacturer: Yup.string().required("Please enter uas manufacturer").trim(),
      uasModel: Yup.string().required("Please enter uas model").trim(),
    }),
    onSubmit: async (values) => {
      try {
        const response = await userService.updatePilotProfile(values);
        const userData = response?.data?.data;
        setUser(userData);
        localStorage.setItem('userData', JSON.stringify(userData));
        handleClose();
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  return (
    <div>
      <div>
        <form>
          <h5 style={{ color:'white'}}>Machine Details</h5>
          <hr />
          <div className=" mb-30">
            <label className="py-2">UAS Manufacturer</label>
            <br />
            <input
              type="text"
              placeholder="Enter UAS Manufacturer"
              className="form-control rounded-3 bg-cyan w-100"
              name="uasManufacturer"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.uasManufacturer}
            />
            {formik.touched.uasManufacturer && formik.errors.uasManufacturer ? (
              <span className="text-danger">{formik.errors.uasManufacturer}</span>
            ) : null}
          </div>
          <div className="mb-30">
            <label className="py-2">UAS Model</label>
            <br />
            <input
              type="text"
              placeholder="Enter UAS Model"
              className="form-control rounded-3 bg-cyan w-100"
              name="uasModel"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.uasModel}
            />
            {formik.touched.uasModel && formik.errors.uasModel ? (
              <span className="text-danger">{formik.errors.uasModel}</span>
            ) : null}
          </div>

          {error && <div className="text-danger">{error}</div>}

          <div className="text-center">
            <button className="btn btn-primary btn-block w-full" type="submit" disabled={formik.isSubmitting} onClick={formik.handleSubmit}>Update</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileForm;
